module.exports = __webpack_public_path__ + "img/12.035a492f.png";